import React, { useEffect, useCallback } from 'react';
import moment from 'moment';
import { Helmet } from "react-helmet";
import { getPedidos } from './../../store/pedidos/pedidos.actions';
import { useSelector, useDispatch } from 'react-redux';
import { Pedclim } from '../../classes/pedido';
import Error from './../../components/Error/Error';
import Spinner from '../../core/Spinner/Spinner';
import Currency from '../../core/Currency/Currency';
import './Orders.scss';

const Orders: React.FC<{}> = React.memo(() => {
    const { pedidos, error, fetching } = useSelector((state: any) => state.pedidosStore);
    const dispatch = useDispatch();

    const fetchPedidos = useCallback(() => {
        dispatch(getPedidos());
    }, [dispatch]);
    
    useEffect(() => fetchPedidos(), [fetchPedidos]);
    
    const renderPedidos = () => {
        if (error) {
            return <Error />;
        }
    
        if (fetching) {
            return <Spinner>Cargando pedidos...</Spinner>;
        }

        if (!pedidos.length) {
            return <p>No se han encontrado pedidos en su historial.</p>
        }

        const a = pedidos.sort((a: any, b: any) => b.FMOV - a.FMOV);

        return a.map((p: Pedclim, index: number) => (
            <div key={index} className="PedidoItem">
                <p className="DateLabel">Fecha del pedido # <b>{p.NPEDIDO}</b></p>
                <p className="DateValue">{moment(p.FMOV).format("DD/MM/YYYY")}</p>

                <p className="SuCompra">Su compra:</p>
                <ul>
                    {p.PEDCLIDS.map((pd: any, i: number) => <li key={i}>{pd.CANT_PED} {pd.CODART && pd.CODART.DESART}</li>)}
                </ul>

                <hr />
                <p className="TotalPedido">Importe: <Currency value={p.TOTAL} /></p>
            </div>
        ));
    };

    return (
        <div className="container SectionContainer">
            <Helmet>
                <title>Linea 2000 | Mis Pedidos</title>
                <meta name="description" content="Fabrica, fracciona y distribuye productos de altísima calidad para un mercado cada vez más exigente." />
                <meta name="keywords" content="acido, ácido, destapa cañerias, canieria, cloro, detergente, jabon, distribuidor, mendoza" />
            </Helmet>
            <h3>Mis Pedidos desde la Web</h3>
            {renderPedidos()}
        </div>
    );
});

export default Orders;